// 通用接口
import { request } from "@/util/request.js"

// 获取轮播图
export function queryBanner(params) {
  return request({
    method: 'get',
    url: '/index/getBanner', // 1首页 2政策资讯 3专业解读 4院校介绍
    params
  })
}

// 获取当前考生所选方案
export function getMyExamineeProgramme(params) {
  return request({
    method: 'post',
    url: 'stuScheme/getProgramme',
    params
  })
}

// 我的收藏列表
export function getCollectList(params) {
  return request({
    url: 'collect/myList',
    method: 'get',
    params
  })
}

// 添加收藏
export function addCollect(data) {
  return request({
    url: 'collect/add',
    method: 'post',
    data
  })
}

// 取消收藏
export function cancelCollect(data) {
  return request({
    url: 'collect/cancel',
    method: 'post',
    data
  })
}

// [学校/专业]是否收藏
export function isCollect(data) {
  return request({
    url: '/collect/isCollect',
    method: 'post',
    data
  })
}

// 获取某专业的招生院校
export function getMajorRelevantSchool(params) {
  return request({
    url: '/majorDetailInfo/getMajorSchool',
    method: 'get',
    params
  })
}

// 获取某专业的招生院校
export function getMajorRelevantSchoolV2(params) {
  return request({
    url: '/majorDetailInfo/getMajorSchoolV2',
    method: 'get',
    params
  })
}

export function getDict(params){
  return request({
    method: 'get',
    url: 'sysDict/getDict',
    params
  })
}
